// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3UY-q","savePackageButton":"ClientWallet_savePackageButton__2Z_Dx"};